module.exports = __webpack_public_path__ + "static/media/icon_close_popup.f1b997b1.svg";